<template>
  <div class="mydevice-bd tb" v-if="funcView.my_biz_device_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.my_biz_device_export" style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.my_biz_device_export }">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_mybizdevice.jshModemSNsbmc')"
            @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- 产品型号 -->
        <el-form-item :label="$t('dms_mybizdevice.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }" :placeholder="$t('Common.com_please_select')"
            width="100%"></custom-select>
        </el-form-item>
        <!-- 启租日期 -->
        <el-form-item :label="$t('dms_mybizdevice.qi_zu_ri_qi')">
          <custom-date-picker v-model="formSearch.rentalDate" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"
            style="width: 100%"></custom-date-picker>
        </el-form-item>
        <!-- 到期日期 -->
        <el-form-item :label="$t('dms_mybizdevice.dao_qi_ri_qi')">
          <custom-date-picker v-model="formSearch.expireDate" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"
            style="width: 100%"></custom-date-picker>
        </el-form-item>
        <!-- 设备退回日期 -->
        <el-form-item :label="$t('dms_mybizdevice.sbthrq')">
          <custom-date-picker v-model="formSearch.backTime" type="daterange" align="right"
            value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"
            style="width: 100%"></custom-date-picker>
        </el-form-item>
        <!-- 库存方 -->
        <el-form-item :label="$t('dms_mybizdevice.ku_cun_fang')">
          <el-input v-model="formSearch.orgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 合同编号 -->
        <el-form-item :label="$t('dms_mybizdevice.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <!-- 订单编号-->
        <el-form-item :label="$t('dms_mybizdevice.sghth')">
          <el-input v-model="formSearch.customContractNo" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.shou_hou_gong_si')">
          <el-input v-model="formSearch.scOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.dai_li_gong_si')">
          <el-input v-model="formSearch.jvOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.zu_lin_fang')">
          <el-input v-model="formSearch.csOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.ji_tuan_ke_hu')">
          <el-input v-model="formSearch.bigCsOrgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.GPSdi_zhi')">
          <el-input v-model="formSearch.gpsAddress" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.ye_wu_yuan')">
          <el-input v-model="formSearch.salesman" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="IMSI">
          <el-input v-model="formSearch.imsi" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_mybizdevice.ji_qi_ban_ben')">
          <el-input v-model="formSearch.machineVersion" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table ref="customTb1" :column="tableColumn" :data="tableList" :index="true" @filter="filterChange" @sort="sortChange"
        height="100%" :slots="['bodyNum', 'action', 'contractNo']">
        <!-- 'isOnline','activateState','siteName','timezone','gpsAddress','lockState' -->
        <template v-slot:bodyNum="scope">
          <div class="cell-link"
            @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum
            }}</div>
        </template>
        <template v-slot:contractNo="scope">
          <div v-if="scope.row.orderId" class="cell-link" @click="onContractNo(scope.row)">{{ scope.row.contractNo }}</div>
          <div v-else>{{ scope.row.contractNo }}</div>
        </template>
        <!-- 操作列 -->
        <template v-slot:action="scope">
          <!-- 激活-->
          <el-button type="text" size="mini" v-if="!scope.row.locationId && funcView.my_biz_device_activate"
            @click="onActiveConfirm(scope.row)">{{ funcView.my_biz_device_activate }}</el-button>
          <!-- 反激活 -->
          <el-button type="text" size="mini" v-if="scope.row.locationId && funcView.my_biz_device_deactivate"
            @click="onUnActiveConfirm(scope.row)">{{ funcView.my_biz_device_deactivate }}</el-button>
          <!-- 更多操作 -->
          <el-dropdown
            v-if="funcView.my_biz_device_modifyDevice || funcView.my_biz_device_usePlace || (funcView.my_biz_device_modifyProject && scope.row.customerId) || funcView.my_biz_device_changeBiztype"
            style="vertical-align: top">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <!-- 合同操作 -->
            <el-dropdown-menu slot="dropdown">
              <!-- 换机 -->
              <el-dropdown-item
                v-if="funcView.my_biz_device_swap && !(userInfo.bizType === 'SC' && userInfo.rootOrgId == scope.row.orgId)"
                @click.native="changeDeviceDialog(scope.row)">
                {{ funcView.my_biz_device_swap }}
              </el-dropdown-item>
              <!-- 变更设备名称 -->
              <el-dropdown-item @click.native="onDeviceNameDialog(scope.row)"
                v-if="funcView.my_biz_device_modifyDevice">{{ funcView.my_biz_device_modifyDevice }}</el-dropdown-item>
              <!-- 变更改使用地点 -->
              <el-dropdown-item @click.native="onlocationDialog(scope.row)" v-if="funcView.my_biz_device_usePlace">{{
                funcView.my_biz_device_usePlace }}</el-dropdown-item>
              <!-- 变更项目 -->
              <el-dropdown-item @click.native="onProjectDialog(scope.row)" v-if="funcView.my_biz_device_modifyProject">{{
                funcView.my_biz_device_modifyProject }}</el-dropdown-item>
              <!-- 修改设备预估类型 -->
              <el-dropdown-item @click.native="changeDeviceBiztype(scope.row)"
                v-if="funcView.my_biz_device_changeBiztype">{{ funcView.my_biz_device_changeBiztype }}</el-dropdown-item>
              <!-- 编辑业务信息 -->
              <el-dropdown-item @click.native="editBizDevice(scope.row)"
                v-if="funcView.my_biz_device_edit_biz_info && !scope.row.contractId && scope.row.contractNo">
                {{ funcView.my_biz_device_edit_biz_info }}
              </el-dropdown-item>
              <!-- 购买数据服务 -->
              <el-dropdown-item @click.native="buyDataService(scope.row)" v-if="buyDataServiceVisible(scope.row)">
                {{ funcView.my_biz_device_buy_sim_service }}
              </el-dropdown-item>
              <!-- 购买数据服务 - 欧美 -->
              <el-dropdown-item @click.native="dataService(scope.row)" v-if="dataServiceVisible(scope.row)">
                {{ funcView.my_biz_device_data_service }}
              </el-dropdown-item>
              <!-- 修改售后公司 -->
              <el-dropdown-item v-if="isHq && funcView.my_biz_device_change_sc_company"
                @click.native="onChangeSc(scope.row)">{{ funcView.my_biz_device_change_sc_company }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <!-- </el-table-column> -->
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
        @change="onPageChange"></custom-page>
    </div>
    <!-- 换机 -->
    <change-device-dialog v-if="changeDeviceVisible" :model="changeDeviceModel" @close="changeDeviceVisible = false"
      @success="getTableList()"></change-device-dialog>
    <!-- 修改设备名称 -->
    <device-rename-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"
      @success="getTableList()"></device-rename-dialog>
    <!--变更使用地点 -->
    <device-location-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"
      @success="getTableList()"></device-location-dialog>
    <!-- 变更项目 -->
    <device-project-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false"
      @success="getTableList()"></device-project-dialog>
    <!-- 激活 -->
    <location-site-select-dialog v-if="dialogVisible6" :model="dialogModel6" @close="dialogVisible6 = false"
      @success="onActiveSuccess"></location-site-select-dialog>
    <!-- 修改设备预估类型 -->
    <change-device-biz-type-dialog v-if="dialogVisible7" :model="dialogModel7" @close="dialogVisible7 = false"
      @success="getTableList()"></change-device-biz-type-dialog>
    <!-- 转移设备/总部转移 -->
    <edit-biz-device-dialog v-if="dialogVisible9" :model="dialogModel9" @close="dialogVisible9 = false"
      @success="getTableList()"></edit-biz-device-dialog>
    <!-- 购买数据服务 -->
    <approval-dialog v-if="dialogVisible8" :model="dialogModel8" @close="dialogVisible8 = false"></approval-dialog>
    <!-- 修改售后公司 -->
    <change-sc-company-dialog v-if="changeScVisible" @close="changeScVisible = false" :model="changeScModel"
      @success="getTableList()"></change-sc-company-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import deviceLocationDialog from '@/pages/dms/components/device_location_dialog.vue';
import deviceProjectDialog from '@/pages/dms/components/device_project_dialog.vue';
import deviceRenameDialog from '@/pages/dms/components/device_rename_dialog.vue';
import changeDeviceDialog from '@/pages/dms/components/changeDeviceDialog.vue';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';
import changeDeviceBizTypeDialog from '@/pages/dms/components/changeDeviceBizTypeDialog.vue';
import editBizDeviceDialog from './children/edit_biz_device_dialog.vue';
import changeScCompanyDialog from './children/change_sc_company_dialog.vue';

export default {
  name: 'mybizdevice',
  mixins: [resetFormSearchMixins, tableFilterValueMixins],
  components: {
    approvalDialog,
    deviceRenameDialog,
    deviceLocationDialog,
    deviceProjectDialog,
    locationSiteSelectDialog,
    changeDeviceBizTypeDialog,
    editBizDeviceDialog,
    changeScCompanyDialog,
    changeDeviceDialog,
  },
  data() {
    return {
      provide: true,
      tableCode: 'my_biz_device',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        salesman: '',
        imsi: '',
        productCode: '',
        rentalDate: '',
        rentStartTime: '', // 启租开始时间
        rentEndTime: '', // 启租结束时间
        expireDate: '',
        expireStartTime: '', // 到期开始时间
        expireEndTime: '', // 到期结束时间
        orgName: '',
        contractNo: '',
        customContractNo: '',
        scOrgName: '',
        jvOrgName: '',
        csOrgName: '',
        bigCsOrgName: '',
        locationName: '',
        gpsAddress: '',
        backTime: '',
        backStartTime: '',
        backEndTime: '',
        machineVersion: '',
      },

      stateDic: {},
      tableList: [],
      totalRows: null,
      // 修改设备名称
      dialogVisible1: false,
      dialogModel1: {},
      // 变更项目
      dialogVisible2: false,
      dialogModel2: {},
      // 变更使用地点
      dialogVisible3: false,
      dialogModel3: {},
      dialogVisible6: false,
      dialogModel6: {},
      dialogVisible7: false,
      dialogModel7: {},
      dialogVisible8: false,
      dialogModel8: {},
      dialogVisible9: false,
      dialogModel9: {},

      // 换机
      changeDeviceModel: {},
      changeDeviceVisible: false,

      // 修改售后公司
      changeScVisible: false,
      changeScModel: {},
      link: null,
      buyDataServiceDialogVisible: false,
    };
  },
  computed: {
    // 是否总部
    isHq() {
      if (this.userInfo) {
        return this.userInfo.bizType === 'HQ';
      }
      return false;
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    isEu() {
      return this.$isEuropeSite();
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDicMap('order_device_biz_state');
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableList();
  },
  methods: {
    // 判断是否显示：购买数据服务
    buyDataServiceVisible(row) {
      // const isEu = this.isEu;
      const userInfo = this.userInfo;
      const funcView = this.funcView;
      const bizState = `${row.bizState}`;
      const simState = `${row.simState}`;
      const ret = !!funcView.my_biz_device_buy_sim_service
        && (bizState === '52')
        && (simState === '0' || simState === '10' || simState === '20') && !!row.agentCoId && (row.agentCoId === userInfo.rootOrgId);

      return ret;

      // if (isEu) {
      //   return (simState === '0' || simState === '10' || simState === '20') && !!funcView.my_biz_device_buy_sim_service;
      // } else {
      //   const ret = !!funcView.my_biz_device_buy_sim_service
      //     && (bizState === '52')
      //     && (simState === '0' || simState === '10' || simState === '20') && !!row.agentCoId && (row.agentCoId === userInfo.rootOrgId);

      //   return ret;
      // }

    },
    // 判断是否显示： 数据服务
    dataServiceVisible(row) {
      const funcView = this.funcView;
      const simState = `${row.simState}`;
      const ret = !!funcView.my_biz_device_data_service
        && (simState === '0' || simState === '10' || simState === '20');

      return ret;
    },
    // 换机
    changeDeviceDialog: function (row) {
      this.changeDeviceModel = { title: this.$t('dms_mybizdevice.huan_ji'), row: row };
      this.changeDeviceVisible = true;
    },
    // 修改售后公司
    onChangeSc(row) {
      this.changeScModel = {
        title: this.$t('dms_mybizdevice.xgshgs'),
        data: row,
      };
      this.changeScVisible = true;
    },
    // 编辑业务信息
    editBizDevice: function (row) {
      this.dialogModel9 = {
        title: this.$t('dms_mybizdevice.bian_ji_ye_wu_xin_xi'),
        type: '',
        row,
      };
      // row: row,
      //   type: this.userInfo.bizType === 'HQ' && this.userInfo.rootOrgId === row.orgId ? 'hq' : '',
      this.dialogVisible9 = true;
    },
    // 购买数据服务
    buyDataService: function (row) {
      this.dialogModel8.type = 'add';
      this.dialogModel8.changeType = 'buy_data_service';
      // if (this.$isEuropeSite()) {
      //   this.dialogModel8.row = { orderId: row.orderId, deviceIdList: [row.deviceId], item: row, };
      // } else {
      //   this.dialogModel8.row = { orderId: row.orderId, deviceIdList: [row.deviceId], };
      // }
      this.dialogModel8.row = { orderId: row.orderId, deviceIdList: [row.deviceId], };

      this.dialogVisible8 = true;
    },
    // 购买数据服务 - 欧美平台
    dataService(row) {
      this.dialogModel8.type = 'add';
      this.dialogModel8.changeType = 'buy_data_service';
      this.dialogModel8.row = { orderId: row.orderId, deviceIdList: [row.deviceId], item: row, };

      this.dialogVisible8 = true;
    },
    // 判断是否显示：购买数据服务
    isShowBuyDataService(row) {
      const map = this.dicMap.order_device_biz_state;
      if (map) {
        return `${row.bizState}` === `${map.ygj}`;
      }
      return false;
    },
    // 修改设备预估类型
    changeDeviceBiztype: function (row) {
      this.dialogModel7.title = this.funcView.my_biz_device_changeBiztype;
      this.dialogModel7.row = row;
      this.dialogVisible7 = true;
    },
    // 设备列表
    getTableList: function () {
      this.formSearch.rentStartTime = this.formSearch.rentalDate && this.formSearch.rentalDate[0] ? this.formSearch.rentalDate[0] : undefined;
      this.formSearch.rentEndTime = this.formSearch.rentalDate && this.formSearch.rentalDate[1] ? this.formSearch.rentalDate[1] : undefined;
      this.formSearch.expireStartTime = this.formSearch.expireDate && this.formSearch.expireDate[0] ? this.formSearch.expireDate[0] : undefined;
      this.formSearch.expireEndTime = this.formSearch.expireDate && this.formSearch.expireDate[1] ? this.formSearch.expireDate[1] : undefined;
      this.formSearch.backStartTime = this.formSearch.backTime && this.formSearch.backTime[0] ? this.formSearch.backTime[0] : undefined;
      this.formSearch.backEndTime = this.formSearch.backTime && this.formSearch.backTime[1] ? this.formSearch.backTime[1] : undefined;

      this.$getJSON(apis.MyDeviceBizPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 合同详情
    onContractNo(row) {
      if (`${row.orderType2}` === '90') {
        this.jump('/contractInvTransDetail', {
          changeId: row.orderId,
          contractId: row.orderId,
          parentPath: '/crmStock/contractInventoryPicking',
        });
      } else {
        this.jump('/contractdetail', {
          contractId: row.orderId,
          contractClass: row.orderType2,
          parentPath: this.$route.path,
        });
      }
    },
    // 激活
    onActiveConfirm: function (row) {
      const title = this.$t('dms_mybizdevice.she_bei_ji_huo');
      this.dialogModel6 = { title, row };
      this.dialogVisible6 = true;
    },
    // 激活成功
    onActiveSuccess: function (form) {
      this.$postJSON(apis.stockActivate, {
        bodyNum: form.row.bodyNum,
        locationId: form.locationId,
        siteId: form.siteId,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getTableList();
      });
    },
    // 反激活
    onUnActiveConfirm: function (row) {
      const subTitle = this.$t('dms_mybizdevice.nqdyfjhsxsb');
      const tips = this.$t('dms_mybizdevice.zfjhhjwfsyzzqjgn');
      this.statusMsg({ subTitle, message: tips, type: 'warning' })
        .then(() => {
          this.$postJSON(apis.stockDeactivate, {
            bodyNum: row.bodyNum,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => { });
    },
    // 修改设备名称
    onDeviceNameDialog: function (row) {
      this.dialogModel1.title = this.$t('dms_mybizdevice.xgsbmc');
      this.dialogModel1.data = row;
      this.dialogVisible1 = true;
    },
    // 使用地点
    onlocationDialog: function (row) {
      this.dialogModel2.title = this.$t('dms_mybizdevice.bgsydd');
      this.dialogModel2.data = row;
      this.dialogVisible2 = true;
    },
    // 修改项目
    onProjectDialog: function (row) {
      this.dialogModel3.title = this.$t('dms_mybizdevice.bian_geng_xiang_mu');
      this.dialogModel3.data = row;
      this.dialogVisible3 = true;
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.MyDeviceBizExport, this.formSearch).then(() => { });
    },
  },
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;

  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 200px;
    display: flex;

    .g2-p1 {
      width: 800px;
      height: 220px;

      &>div {
        top: -50px;
        left: -20px;
      }
    }

    .g2-p2 {
      width: 400px;
      height: 200px;

      &>div {
        left: -220px;
      }
    }
  }

  .product-wrap {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 16px;
    background-color: #ffffff;
  }

  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;

        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }

        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }

        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }

        .img-box {
          font-size: 0;
          height: 180px;

          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }

        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }

        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
